import React from 'react'
import StackBarChartPanel from '../../../components/Charts/StackBarChartPanel'
import FilterPanel from '../components/FilterPanel'

const BettingReportByUser = () => {
  return (
    <div className='p-2'>
         <div className='flex justify-between border-b border-b-gray-300 pb-2 mb-1'>
            <h6 className="font-semibold">Betting Report By User</h6>
            <FilterPanel/>
        </div>
        <div className="w-full h-[250px]">
              <StackBarChartPanel _data={data}/>
        </div>
    </div>
  )
}

export default BettingReportByUser;

const data = [
  {
    "date" : "2024-01-01",
    "bettedUser" : 40,
    "loggedUser" : 30
  },
  {
    "date" : "2024-01-02",
    "bettedUser" : 50,
    "loggedUser" : 10
  },
  {
    "date" : "2024-01-03",
    "bettedUser" : 60,
    "loggedUser" : 20
  },
  {
    "date" : "2024-01-04",
    "bettedUser" : 40,
    "loggedUser" : 15
  },
  {
    "date" : "2024-01-05",
    "bettedUser" : 40,
    "loggedUser" : 25
  },
  {
    "date" : "2024-01-06",
    "bettedUser" : 40,
    "loggedUser" : 26
  },
  {
    "date" : "2024-01-07",
    "bettedUser" : 70,
    "loggedUser" : 20
  }
]